import LegalPage from './LegalPage';

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Politique de confidentialite"
      subtitle="Cette politique explique comment Foi Senegal collecte, utilise, protege et supprime les donnees personnelles des utilisateurs."
      updatedAt="Derniere mise a jour : 11 juin 2026"
      intro="Foi Senegal s'engage a proteger la vie privee de ses utilisateurs. Nous collectons uniquement les informations necessaires au fonctionnement de l'application mobile et des services associes."
      sections={[
        {
          title: '1. Donnees collectees',
          body: "Nous pouvons collecter le nom, le prenom, l'adresse email, le numero de telephone, l'adresse, la paroisse, la photo de profil, les favoris, les demandes de messe, les reservations, les commandes, les tickets, les notifications et les informations techniques necessaires a la securite du service.",
        },
        {
          title: '2. Utilisation des donnees',
          body: "Les donnees servent a gerer le compte utilisateur, afficher les eglises et horaires, traiter les demandes de messe, commandes, reservations et tickets, envoyer des notifications utiles, assurer le support et ameliorer la qualite du service.",
        },
        {
          title: '3. Localisation',
          body: "Avec l'autorisation de l'utilisateur, Foi Senegal utilise la localisation pour afficher les eglises les plus proches. La localisation n'est pas vendue et n'est pas utilisee a des fins publicitaires.",
        },
        {
          title: '4. Partage des donnees',
          body: "Les donnees ne sont pas vendues a des tiers. Elles peuvent etre partagees uniquement avec les prestataires techniques necessaires au fonctionnement du service, au paiement, a l'hebergement, a la messagerie ou a l'assistance, dans la limite de leurs missions.",
        },
        {
          title: '5. Conservation et suppression',
          body: "Les donnees du compte sont conservees pendant la duree d'utilisation du service. Apres une demande de suppression de compte, les donnees personnelles non soumises a une obligation legale ou comptable sont supprimees ou anonymisees dans un delai maximum de 90 jours. Certaines donnees de paiement, facturation ou securite peuvent etre conservees plus longtemps si la loi l'exige.",
        },
        {
          title: '6. Droits des utilisateurs',
          body: "Chaque utilisateur peut demander l'acces, la correction, l'opposition au traitement ou la suppression de ses donnees. Pour exercer ces droits, il faut envoyer une demande a foisenegal@gmail.com avec l'adresse email associee au compte.",
        },
        {
          title: '7. Securite',
          body: "Nous mettons en place des mesures techniques et organisationnelles pour proteger les informations contre l'acces non autorise, la perte, l'alteration ou la divulgation.",
        },
        {
          title: '8. Contact',
          body: "Pour toute question relative a la confidentialite ou aux donnees personnelles, contactez Foi Senegal a l'adresse foisenegal@gmail.com.",
        },
      ]}
    />
  );
}
